import { LoadableAfterPaint } from '@confluence/loadable';

export const ExcerptIncludeSSRExtensionHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExcerptIncludeSSRExtensionHandler" */ '../src/ExcerptIncludeSSRExtensionHandler.tsx'
			)
		).ExcerptIncludeSSRExtensionHandler,
});
